import { render, staticRenderFns } from "./userLogin.vue?vue&type=template&id=72d23b82&scoped=true"
import script from "./userLogin.vue?vue&type=script&lang=js"
export * from "./userLogin.vue?vue&type=script&lang=js"
import style0 from "./userLogin.vue?vue&type=style&index=0&id=72d23b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d23b82",
  null
  
)

export default component.exports